import { create } from "zustand"
import { persist } from "zustand/middleware"
import type { ILoggedUser } from "@/entities/auth/types.ts"
import { Auth } from "@/shared/lib"
import type { ZustandPersistedStore } from "@/shared/types"

interface State {
  loading: boolean
  sidebarIsOpened: boolean
  isAuthorized: boolean
  isDarkTheme: boolean
  me?: ILoggedUser
  // loadingTranslations: boolean
}

interface Helpers {
  toggleSidebar: VoidFunction
  changeTheme: VoidFunction
  authorize: VoidFunction
  logout: VoidFunction
  saveUser: (user: ILoggedUser) => void
  selectAuthState: (state: State) => boolean
}

interface Actions {
  // loadTranslations: VoidFunction
  // loadSystemResources: VoidFunction
  reset: () => void
}

const INIT: State = {
  sidebarIsOpened: true,
  isAuthorized: false,
  isDarkTheme: false,
  loading: true
  // loadingTranslations: true
}

const useGlobal = create<State & Actions>()(
  persist(
    (set, get) => ({
      ...INIT,
      // loadTranslations: async () => {
      // set({ loadingTranslations: true, loading: true })
      // await initializeI18n()
      // await i18n.changeLanguage(currLang)
      // set({ loadingTranslations: false, loading: false })
      // },
      // loadSystemResources: async () => {
      //   // if (!get().isAuthorized) return
      //   set({ loading: true, loadingTranslations: false })
      //   try {
      //     if ((gt("yes") ?? "").length === 0) await initializeI18n()
      //     // await me()
      //     //   .then(data => {
      //     //     if (data.permissions != null && data.roles != null) {
      //     //       usePermissions.getState().setData({ permissions: data.permissions ?? [], roles: data.roles ?? [] })
      //     //     }
      //     //     set({ loading: false, me: data, isAuthorized: true })
      //     //   })
      //     //   .catch((e: unknown) => {
      //     //     Notice.error((e as { data?: { detail?: string } })?.data?.detail ?? "Error when get me")
      //     //     set({ loading: false, isAuthorized: false })
      //     //     Auth.logout()
      //     //   })
      //   } catch {
      //     Notice.error("Error")
      //     set({ ...INIT, loadingTranslations: false, loading: false })
      //   }
      // },
      reset: () => set({ ...INIT, isDarkTheme: get().isDarkTheme })
    }),
    {
      name: "GLOBAL_SETTINGS",
      partialize: state => ({
        me: state.me,
        sidebarIsOpened: state.sidebarIsOpened,
        isAuthorized: state.isAuthorized,
        isDarkTheme: state.isDarkTheme
      })
    }
  )
) as ZustandPersistedStore<State & Actions, Helpers>

const toggleSidebar = () => useGlobal.setState(old => ({ ...old, sidebarIsOpened: !old.sidebarIsOpened }))
const changeTheme = () => useGlobal.setState(old => ({ ...old, isDarkTheme: !old.isDarkTheme }))
const authorize = () => useGlobal.setState(old => ({ ...old, isAuthorized: true }))
const logout = () => {
  Auth.logout()
  useGlobal.setState(old => ({ ...old, isAuthorized: false, me: {} as ILoggedUser }))
}
const saveUser = (user: ILoggedUser) => useGlobal.setState(old => ({ ...old, me: user, isAuthorized: true }))
const selectAuthState = (state: State) => state.isAuthorized

useGlobal.toggleSidebar = toggleSidebar
useGlobal.changeTheme = changeTheme
useGlobal.authorize = authorize
useGlobal.logout = logout
useGlobal.saveUser = saveUser
useGlobal.selectAuthState = selectAuthState

export { useGlobal }
